import { AuthProvider } from '@teamexos/fit-shared';
import { SnackbarContextProvider } from 'contexts/snackbarContext';
import SplitProvider from 'contexts/splitContext';
import useMixpanel from 'hooks/useMixpanel';
import React from 'react';
import { FirebaseProvider } from '../contexts/firebaseContext';
import PrinceSDKProvider from '../contexts/princeSDKContext';
import { MixpanelProvider } from '../utils/mixpanel';
import InactivityProvider from './InactivityProvider';
import ThemeProviders from './ThemeProviders';
import TrackingEventListProvider from './TrackingEventListProvider';

const sharedPlatformDomain = process.env.REACT_APP_PRINCE_GQL_URL;

if (!sharedPlatformDomain) {
  throw new Error('REACT_APP_PRINCE_GQL_URL is not defined');
}

const Providers: React.FC<React.PropsWithChildren> = ({ children }) => (
  <FirebaseProvider>
    <PrinceSDKProvider>
      <SplitProvider>
        <MixpanelProvider token={process.env.REACT_APP_MIXPANEL_TOKEN}>
          <AuthProvider
            sharedPlatformDomain={sharedPlatformDomain}
            trackHook={useMixpanel}
            localSignOut={async () => {}}
          >
            <ThemeProviders>
              <SnackbarContextProvider>
                <InactivityProvider>
                  <TrackingEventListProvider>
                    {children}
                  </TrackingEventListProvider>
                </InactivityProvider>
              </SnackbarContextProvider>
            </ThemeProviders>
          </AuthProvider>
        </MixpanelProvider>
      </SplitProvider>
    </PrinceSDKProvider>
  </FirebaseProvider>
);

export default Providers;
